import { domains } from '@/mocks/domains';

export default function DomainList() {
  return (
    <section id="domain-list" className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 bg-accent-100 text-accent-800 text-xs font-medium rounded-full mb-4">
            实时更新
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            黑料网<strong className="text-primary-600">永久域名</strong>列表
          </h2>
          <p className="text-sm text-foreground-600 max-w-lg mx-auto">
            以下是目前所有可用的黑料网域名地址，均经过人工验证，确保真实有效。建议收藏多个域名以备不时之需。
          </p>
          <p className="text-xs text-foreground-400 mt-2">
            最后更新：2026年8月7日 · 当前可用域名：{domains.length} 个
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {domains.map((domain, index) => (
            <article
              key={domain.id}
              className="bg-background-50 rounded-lg p-5 border border-background-200/70 hover:border-primary-300/50 transition-all duration-300 group cursor-pointer"
            >
              <div className="flex items-start justify-between mb-3">
                <span className="px-2.5 py-0.5 bg-accent-100 text-accent-800 text-xs font-medium rounded-full">
                  {domain.label}
                </span>
                <span className="flex items-center gap-1 text-xs text-accent-600">
                  <span className="w-1.5 h-1.5 bg-accent-400 rounded-full"></span>
                  可用
                </span>
              </div>
              <a
                href={domain.url}
                target="_blank"
                rel="nofollow noopener noreferrer"
                className="block text-base font-medium text-foreground-900 group-hover:text-primary-600 transition-colors mb-2 break-all cursor-pointer"
              >
                {domain.url}
              </a>
              <p className="text-xs text-foreground-500 leading-relaxed mb-3">
                {domain.description}
              </p>
              <div className="flex items-center justify-between">
                <span className="text-xs text-foreground-400">
                  更新于 {domain.updatedAt}
                </span>
                <a
                  href={domain.url}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="flex items-center gap-1 text-xs text-primary-600 hover:text-primary-700 font-medium transition-colors cursor-pointer whitespace-nowrap"
                >
                  立即访问 <i className="ri-arrow-right-up-line text-sm"></i>
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}